import React, { useState } from 'react'
import moment from 'moment'
import { SxProps, Theme } from '@mui/material'
import { Chip, Tooltip } from '@common/material'
import { localizedStrings } from '@core/strings'
import { CheckInSession } from '@core/entities/checkIn'
import Countdown from '@core/Countdown'
import useFeatureFlags from '@core/providers/useFeatureFlags'

type ComponentType = {
  session?: CheckInSession
  size?: 'small' | 'medium'
  sx?: SxProps<Theme>
}

export const CheckInStatusChip: React.FC<ComponentType> = ({
  session,
  size = 'small',
  sx,
}) => {
  const { flags } = useFeatureFlags(['web_permit_check_in'])
  const [expired, setExpired] = useState(false)
  const overdue = expired || !!session?.isOverdue()
  const tooltip = `${localizedStrings.checkedInAt(
    moment(session?.checkedInOn).format('HH:mm'),
  )} · ${localizedStrings.expectedCheckOut(
    moment(session?.expectedCheckOutOn).format('HH:mm'),
  )}`

  if (!flags.web_permit_check_in || !session?.isOpen()) return null

  return (
    <Tooltip title={tooltip}>
      <Chip
        label={
          <>
            <span>
              {overdue ? localizedStrings.overdue : localizedStrings.onSite}
            </span>
            <span> – </span>
            <Countdown
              pollFrequency={1000}
              value={session.expectedCheckOutOn}
              countUp={overdue}
              onExpire={() => setExpired(true)}
            />
          </>
        }
        color={overdue ? 'error' : 'success'}
        size={size}
        sx={sx}
        data-test={
          overdue ? 'check-in-status-overdue' : 'check-in-status-checked-in'
        }
      />
    </Tooltip>
  )
}
